import PropTypes from "prop-types";
import React from "react";
import { LabelWithIcon } from "./LabelWithIcon";

export const FieldRow = ({ label, tooltip, children }) => (
  <tr>
    <th style={{ width: "45%" }} className="text-grey-dark mr-3">
      <LabelWithIcon label={label} tooltip={tooltip} />
    </th>
    <td style={{ width: "55%" }} className="text-black">
      {children}
    </td>
  </tr>
);

FieldRow.propTypes = {
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  children: PropTypes.node,
};

export default FieldRow;
